export const handleCreateUser = async (object:createUserObject) => {
    let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}userCreate`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},  
        body: JSON.stringify(object)
    })

    try {
        let r = await f.json() as Call;
        return r;
    }

    catch {
        return { errorcode: 999, message: "Failed"} as Call
    }
}

export const getAllUsers = async (object:UserData) => {
    let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}usersAll?token=${object.token}`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},  
    })

    try {
        const r = await f.json() as Call;
        return r;
    }

    catch {
        return { errorcode: 999, message: "Failed", object: {}} as Call
    }
}

export const handleDeleteUser = async (userid:number, object:UserData) => {
    let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}userDelete?token=${object.token}&userid=${userid}`, {
        method: 'DELETE',
        headers: {'Content-Type': 'application/json'},  
    })

    try {
        const r = await f.json() as Call;
        return r;
    }

    catch {
        return { errorcode: 999, message: "Failed", object: {}} as Call
    }
}

export const handleUpdateUser = async (object:UpdateUserObject) => {
    let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}userUpdate`, {
        method: 'PUT',
        headers: {'Content-Type': 'application/json'}, 
        body: JSON.stringify(object)
    })

    try {
        const r = await f.json() as Call;
        return r;
    }

    catch {
        return { errorcode: 999, message: "Failed", object: {}} as Call
    }
}

export const handleSendMail = async (userid:number, object:UserData) => {
    let f = await fetch(`${process.env.REACT_APP_SERVER_LINK}registrationResend?token=${object.token}&userid=${userid}`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},  
    })

    try {
        const r = await f.json() as Call;
        return r;
    }

    catch {
        return { errorcode: 999, message: "Failed", object: {}} as Call
    }
}